import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRemoteFinish } from 'app/interfaces/IRemoteFinish';
import { IRemotePowerDetails } from 'app/interfaces/IRemotePowerDetails';
import { IWriteResult } from 'app/interfaces/IWriteResult';
import { KeycloakService } from 'app/login/keycloak.service';
import { EventsService } from 'app/_services/events.service';
import { LayersService } from 'app/_services/layers.service';
import { RemotePowerService } from 'app/_services/remote-power.service';
import { TabledataService } from 'app/_services/tabledata.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-remote-power-details-table',
    templateUrl: './remote-power-details-table.component.html',
    styleUrls: ['./remote-power-details-table.component.css'],
    providers: [RemotePowerService],
    standalone: false
})
export class RemotePowerDetailsTableComponent implements OnInit {
  @Input() detailsTableData: any[] = [];
  @Input() detailsData: IRemotePowerDetails;
  @Output() dataTableEmmiter: EventEmitter<any> = new EventEmitter<any>();
  headers: Array<any> = [];
  public message: string;

  selectedIndex: number;
  selectedData: any;

  midparameter: number;
  obmidsparameter: string;
  constructor(
    private layersService: LayersService,
    private remoteService: RemotePowerService,
    private eventService: EventsService,
    private confirmationService: ConfirmationService,
    private tableService: TabledataService) { }

  ngOnInit() {
    this.headers = Object.keys(this.detailsTableData[0]).filter(data => !data.startsWith("_"))
    this.layersService.subscribeLayersGroupLoadListener().subscribe(
      data => {
        if (data.ob_mid !== undefined) {
          // console.log("load layer group ob mid:"+data.ob_mid);
          console.log("pc!!", data);

          this.obmidsparameter = data.ob_mids;
          this.midparameter = data.ob_mid;

        }
        else {
          console.log("load layer group error: data undefined ");

        }
      },
      err => { console.log(err) }

    );
  }

  onSubmit() {
    const selected = this.detailsTableData.find(e => e?._selected);

    if (!selected) {
      console.warn('No row selected');
      return;
    }

    const obj: IRemoteFinish = {
      mid: this.midparameter,
      userId: KeycloakService.auth.authz.subject,
      areaId: Number(this.detailsData.areaId),
      technologyId: selected._id_tehnologije
    };

    const opisRaw = selected?._omejitve_opis ?? '';
    const opisHtml = String(opisRaw)
      .replace(/\$/g, '')
      .replace(/nl/g, '<br> <br>');

    const el = document.getElementsByClassName('ui-confirmdialog-message')?.[0] as HTMLElement | undefined;
    if (el) el.innerHTML = opisHtml;

    this.message = opisHtml;

    if ((selected?.omejitve ?? '').toUpperCase() === 'DA') {
      this.confirmationService.confirm({
        message: this.message,
        header: 'Omejitve',
        accept: () => this.postData(obj)
      });
    } else {
      this.postData(obj);
    }
  }

  private postData(obj: IRemoteFinish){
    this.remoteService.postRemotePowerDetialsTableResults(obj).subscribe({
      next: (response: IWriteResult) => {
        console.warn("postRemotePowerDetialsTableResults", response)
        // response._report_name = "Alo buraz"
        this.showData(response);
        this.dataTableEmmiter.emit({open: false, response: response});
      },
      error: err => console.error(err)
    })
  }

  onPageChange(event) {

  }
  onRowSelect(item, index) {
    console.log(item, index)
    this.selectedData = item;
    this.selectedIndex = index;
    this.detailsTableData.forEach(element => {
      if (element._selected) element._selected = false;
    });
    this.detailsTableData[index]._selected = true;
  }
  onRowUnselect(event) {

  }

  sortTable(n) {
    var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
    table = document.getElementById("details-table");
    switching = true;
    // Set the sorting direction to ascending:
    dir = "asc";
    /* Make a loop that will continue until
    no switching has been done: */
    while (switching) {
      // Start by saying: no switching is done:
      switching = false;
      rows = table.rows;
      /* Loop through all table rows (except the
      first, which contains table headers): */
      for (i = 1; i < (rows.length - 1); i++) {
        // Start by saying there should be no switching:
        shouldSwitch = false;
        /* Get the two elements you want to compare,
        one from current row and one from the next: */
        x = rows[i].getElementsByTagName("TD")[n];
        y = rows[i + 1].getElementsByTagName("TD")[n];
        /* Check if the two rows should switch place,
        based on the direction, asc or desc: */
        if (dir == "asc") {
          if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        } else if (dir == "desc") {
          if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
            // If so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        /* If a switch has been marked, make the switch
        and mark that a switch has been done: */
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        // Each time a switch is done, increase this count by 1:
        switchcount++;
      } else {
        /* If no switching has been done AND the direction is "asc",
        set the direction to "desc" and run the while loop again. */
        if (switchcount == 0 && dir == "asc") {
          dir = "desc";
          switching = true;
        }
      }
    }
  }



  private showData(data: any): void {

    if (data.status === true) {
      let tabels = [];
      if (data.dependendLayerIds) {
        tabels = tabels.concat(data.dependendLayerIds);
      }
      tabels.unshift(data.webappLayerId);

      console.warn("TABLE", tabels)

      tabels.forEach((id, index) => {

        let node = this.layersService.findNodeById(id);
        if (node !== null) {
          this.eventService.sendTreeNodeOnOffEvt({ id: id, ison: true });
          node.data.showtable = true;
          node.data.tabledataloaded = false;
          console.warn("NODE", node)
          this.tableService.setRequestTableData(node);
          var s1 = this.tableService.subscribeDataListener().subscribe(response => {
            console.warn("response", response)
            this.tableService.setShowTable(node.data.id, true, node.label, node);
            s1.unsubscribe();
          });

          //console.log("find node in tree",node);
        }
      });
    }
  }
}
